import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import { t } from '~/helpers';

import MyForm from './form';

const formRef = createRef();

class Deletar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      params: {},
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  // Close modal
  async handleCloseModal() {
    await this.setState({ open: false });
  }

  render() {
    const { open, params } = this.state;

    return (
      <Dialog
        open={open}
        onClose={() => this.handleCloseModal()}
        fullScreen={window.innerWidth <= 450}
      >
        <DialogTitle>
          {'Deletar Registro'}
        </DialogTitle>
        <DialogContent>
          <MyForm
            data={params}
            reference={formRef}
            close={() => {
              this.handleCloseModal();
              this.props.update();
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={() => formRef.current.submitForm()}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>

          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => this.handleCloseModal()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(Deletar);
